import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, Input, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { register } from 'swiper/element/bundle';


register();

@Component({
  selector: 'app-contest-banners',
  templateUrl: './contest-banners.component.html',
  styleUrls: ['./contest-banners.component.scss'],
})
export class ContestBannersComponent  implements OnInit {
  @Input() contest: any;
  banners: any[] = [];

  @ViewChild('swiperRef', { static: false }) swiperRef?: ElementRef;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.banners = (this.contest || []).flatMap((item: any) =>
      (item.banners || []).map((banner: any) => ({
        ...banner,
        contestName: item.name,
        contestId: item.id
      }))
    );

    // 2. Le damos un pequeñísimo tiempo a Angular para pintar el HTML
    // y luego forzamos a Swiper a recalcular cuántas imágenes tiene.
    setTimeout(() => {
      if (this.swiperRef?.nativeElement?.swiper) {
        this.swiperRef.nativeElement.swiper.update();
      }
    }, 50);
  }

}
